import { useContext } from 'react';
import { ToggleUploadDisplayContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useToggleUploadDisplay = () => {
  return useContext(ToggleUploadDisplayContext);
};

export default useToggleUploadDisplay;